var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatWeDoIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3469 3.89326L25.2135 7.38659C27.4802 8.38659 27.4802 10.0399 25.2135 11.0399L17.3469 14.5333C16.4535 14.9333 14.9869 14.9333 14.0935 14.5333L6.22686 11.0399C3.96019 10.0399 3.96019 8.38659 6.22686 7.38659L14.0935 3.89326C14.9869 3.49326 16.4535 3.49326 17.3469 3.89326Z",
    stroke: "#A8A8A8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.6667C4 15.7867 4.84 17.08 5.86667 17.5334L14.92 21.56C15.6133 21.8667 16.4 21.8667 17.08 21.56L26.1333 17.5334C27.16 17.08 28 15.7867 28 14.6667",
    stroke: "#A8A8A8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21.3333C4 22.5733 4.73333 23.6933 5.86667 24.2L14.92 28.2266C15.6133 28.5333 16.4 28.5333 17.08 28.2266L26.1333 24.2C27.2667 23.6933 28 22.5733 28 21.3333",
    stroke: "#A8A8A8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatWeDoIcon01);
export default __webpack_public_path__ + "static/media/what-we-do-icon01.fa52717a09c2e488f228ce0d6b740937.svg";
export { ForwardRef as ReactComponent };